// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2uyBc","content":"styles_content__2sD0R","selectAll":"styles_selectAll__91Ucm"};